export default "__VITE_ASSET__BeA$uSkw__"